var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNurse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 214.98 214.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff160a;}.cls-2,.cls-3{opacity:0.2;}.cls-3,.cls-4{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Nurse") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5956.15-2712.52A107.52,107.52,0,0,0,5848.63-2820a107.47,107.47,0,0,0-107.46,107.46A107.48,107.48,0,0,0,5848.63-2605,107.53,107.53,0,0,0,5956.15-2712.52Z",
    transform: "translate(-5741.17 2819.98)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5848.63-2621a107.47,107.47,0,0,1-107.16-99.51q-.3,4-.3,8A107.48,107.48,0,0,0,5848.63-2605a107.53,107.53,0,0,0,107.52-107.52q0-4-.3-8A107.53,107.53,0,0,1,5848.63-2621Z",
    transform: "translate(-5741.17 2819.98)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5848.63-2804a107.53,107.53,0,0,1,107.22,99.47q.3-4,.3-8A107.52,107.52,0,0,0,5848.63-2820a107.47,107.47,0,0,0-107.46,107.46q0,4,.3,8A107.48,107.48,0,0,1,5848.63-2804Z",
    transform: "translate(-5741.17 2819.98)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M5906.29-2692.15a4.68,4.68,0,0,0,0-6.64,4.68,4.68,0,0,0-6.64,0l-5.15,5.14-67.91-67.9a4.7,4.7,0,0,0-2.1-1.22l-22.81-6.11a4.71,4.71,0,0,0-4.54,1.22l-1.4,1.4-6.16-6.16a4.7,4.7,0,0,0-6.65,0,4.7,4.7,0,0,0,0,6.64l6.17,6.17-1.41,1.4a4.7,4.7,0,0,0-1.21,4.54l6.11,22.8a4.72,4.72,0,0,0,1.21,2.11l67.91,67.9-5.15,5.15a4.71,4.71,0,0,0,0,6.65,4.71,4.71,0,0,0,3.32,1.37,4.72,4.72,0,0,0,3.33-1.37l8.47-8.47h0l13.07-13.07Zm-37.93,24.64-7.88-7.87,8.74-8.75a4.68,4.68,0,0,0,0-6.64,4.68,4.68,0,0,0-6.64,0l-8.75,8.74-7.87-7.87,8.74-8.75a4.68,4.68,0,0,0,0-6.64,4.7,4.7,0,0,0-6.65,0l-8.74,8.74-7.88-7.88,8.75-8.74a4.71,4.71,0,0,0,0-6.65,4.71,4.71,0,0,0-6.65,0l-8.74,8.75-7.88-7.88,8.75-8.74a4.71,4.71,0,0,0,0-6.65,4.7,4.7,0,0,0-6.65,0l-8.74,8.74-8.93-8.92-5.08-19,5.61-5.62,19,5.09,67,67-9.75,9.75Z",
    transform: "translate(-5741.17 2819.98)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M5914.38-2672.27a4.68,4.68,0,0,0-6.64,0l-2.16,2.16-2.1-2.1h0l-.11-.13a4,4,0,0,0-5.6,0L5883-2657.6a4,4,0,0,0,0,5.6l.13.11h0l2.1,2.1-2.16,2.16a4.7,4.7,0,0,0,0,6.65,4.66,4.66,0,0,0,3.32,1.38,4.68,4.68,0,0,0,3.32-1.38l24.65-24.65A4.7,4.7,0,0,0,5914.38-2672.27Z",
    transform: "translate(-5741.17 2819.98)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNurse);
export default __webpack_public_path__ + "static/media/Nurse.b3a0da749d1cbfc3d64a2bb497828453.svg";
export { ForwardRef as ReactComponent };